import { createStore, combineReducers } from 'redux';
import { updateArticleContent } from '@/reducer/rdc_article';

const AppStore = combineReducers({
  updateArticleContent
});

export default createStore(AppStore);